<main-app-header></main-app-header>

<div class="media-page">
  <div class="media-container">
    <h2 class="page-title">Titanium Media Highlights</h2>

    <div class="media-grid">
      <!-- Item 1 -->
      <article class="media-card">
        <header class="media-card__header">
          <h5 class="media-card__title">Protecting Your Privacy in a Digital Age</h5>
        </header>

        <div class="embed-wrap">
          <div class="embed">
            <iframe
              src="https://www.youtube.com/embed/LuRPDtD9sXQ"
              title="Protecting Your Privacy in a Digital Age"
              allowfullscreen>
            </iframe>
          </div>
        </div>
      </article>

      <!-- Item 2 -->
      <article class="media-card">
        <header class="media-card__header">
          <h5 class="media-card__title">Titanium Secure: Quantum-Resistant Defense Against Cyberattack</h5>

          <a class="media-card__link"
             href="https://www.dailysignal.com/2025/04/27/new-secure-messaging-platform-offers-quantum-resistant-defense-against-chinese-cyber-threats/"
             target="_blank" rel="noopener noreferrer">
            Read the article on The Daily Signal
          </a>
        </header>

        <div class="embed-wrap">
          <div class="embed">
            <iframe
              src="https://www.youtube.com/embed/PQtRTHAyLuM"
              title="Titanium Secure: Quantum-Resistant Defense Against Cyberattack"
              allowfullscreen>
            </iframe>
          </div>
        </div>
      </article>

      <!-- Item 3 -->
      <article class="media-card">
        <header class="media-card__header">
          <h5 class="media-card__title">They’re Tracking Everything—Here’s How to Take Your Privacy Back</h5>
        </header>

        <div class="embed-wrap">
          <div class="embed">
            <iframe
              src="https://www.youtube.com/embed/HDwC0ZJNky8"
              title="They’re Tracking Everything—Here’s How to Take Your Privacy Back"
              allowfullscreen>
            </iframe>
          </div>
        </div>
      </article>

      <!-- Item 4 -->
      <article class="media-card">
        <header class="media-card__header">
          <h5 class="media-card__title">With Robert Charles &amp; Dr. John Reese (Last 8 Minutes)</h5>

          <a class="media-card__link"
             href="https://rumble.com/v6tbu31-with-robert-charles-and-dr.-john-reese.html?t=1900"
             target="_blank" rel="noopener noreferrer">
            Watch from 31:38 mark on Rumble
          </a>
        </header>

        <div class="embed-wrap">
          <div class="embed">
            <iframe
              src="https://rumble.com/embed/v6r4xu7/?pub=4"
              title="With Robert Charles & Dr. John Reese (Last 8 Minutes)"
              allowfullscreen>
            </iframe>
          </div>
        </div>
      </article>

      <!-- Item 5 -->
      <article class="media-card">
        <header class="media-card__header">
          <h5 class="media-card__title">Are China and Others Listening to Your Conversations?</h5>

          <a class="media-card__link"
             href="https://rumble.com/v6t2x9t-are-china-and-others-listening-to-your-conversations-guest-dr.-john-reese-e.html"
             target="_blank" rel="noopener noreferrer">
            Watch on Rumble
          </a>
        </header>

        <div class="embed-wrap">
          <div class="embed">
            <iframe
              src="https://rumble.com/embed/v6qw10z/?pub=4"
              title="Are China and Others Listening to Your Conversations?"
              allowfullscreen>
            </iframe>
          </div>
        </div>
      </article>
    </div>
  </div>
</div>
